import { Component, Input, OnInit } from '@angular/core';
import { CriterionsService } from '../../../../services/criterions.service';
import { Category } from '../../../../models/category.model';

@Component({
  selector: 'app-masar-total-statistic-preview',
  templateUrl: './masar-total-statistic-preview.component.html',
  styleUrls: ['./masar-total-statistic-preview.component.scss']
})
export class MasarTotalStatisticPreviewComponent implements OnInit {
  @Input() category: Category;
  process$ = this.criterionsService.process$;

  constructor(private criterionsService: CriterionsService) { }

  ngOnInit() {
  }

}
